import {useEffect,} from 'react';

import {useInvoices} from '../hooks/useInvoices';
import {Invoice} from '../types';
import {FieldProps} from 'formik';
import {useAuth} from "../../../hooks/useAuth.ts";
import {FormikGenericCombobox} from "@flexinet/ui-components";
import {TextInputProps} from "@mantine/core";


export const InvoicesAutocomplete = (props: FieldProps & TextInputProps) => {

    const {user} = useAuth()

    if (!user) {
        throw new Error('user is required parameter')
    }

    const {
        items: records,
        loading,
        fetchRecords
    } = useInvoices();


    useEffect(() => {
        fetchRecords();
    }, []);


    return (

        <FormikGenericCombobox
            records={records || []}
            valueFieldName={'id'}
            renderOption={(record: Invoice) => `${record.id} ${record.customer?.name}`}
            getSelectedOption={(record: Invoice) => `${record.id} ${record.customer?.name}`}
            isLoading={loading}
            {...props}
        />

    );
};

